import { DataBean } from "../DataBean";

export class QualityInspection extends DataBean {

  public async getQualityInspectionCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getQualityInspectionCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getQualityInspectionRender(page:number, rows:number, properties: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.Report_getQualityInspectionRender_Number_Number_java.util.Map",
      [page, rows, properties]
    );
  }

  public async deleteQualityInspection(idqualityinspection: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "boolean_deleteQualityInspection_Number", [idqualityinspection]);
  }

  public async updateQualityInspection(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.QualityInspection_updateQualityInspection_com.orange.finance.processcontract.bean.QualityInspection",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.QualityInspection",
        },
      ]
    );
  }
}
